import { mediaGQLFields } from '../media/index.js'

export const spaceNotificationSettingsFields = () => `
    __typename
    space {
      __typename
      id
      name
      slug
      relativeUrl
      url
      image {
        ${mediaGQLFields('basic')}
      }
    }
    channel
    isDefault
    preference
    sameAsDefault
`
